module.exports = __webpack_public_path__ + "static/2front-hasta-3-5557b19a9f6b12f05f183b58e445b153.png";